import React from "react";
import { useLocation } from "react-router-dom";
import MPMCModuleSubtopic from "../MPMCModuleSubtopic";

const MPMC_Stack = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <MPMCModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Data Processing - Stack"
      videos={[
        "https://www.youtube.com/embed/vgI6XuKDn-U", // Stack of 8051 Microcontroller - PUSH & POP Instructions
      ]}
      takeaways={[
        { text: "Understand how values move between register banks using the stack." },
        { text: "Learn how to use the Program Status Word (PSW) to change register banks." },
        { text: "Familiarize yourself with PUSH and POP instructions in the 8051 microcontroller." },
      ]}
      questions={[]} // No specific previous questions provided
      exampleVideos={[]} // No example question videos provided
    />
  );
}

export default MPMC_Stack;
